import { Component } from '@angular/core';
import { MovieService } from '@usheru-hff/sdk/movie';
import { ActivatedRoute } from '@angular/router';
import { ChannelService } from '@usheru-hff/sdk/channel';
import { Movie } from '@usheru-hff/shared/domain';

export const productionsTranslations: Record<string, string> = {
  'upcoming-productions': $localize`:@@catalog.title.tag.upcoming-productions:Upcoming Productions`,
  'past-productions': $localize`:@@catalog.title.tag.past-productions:Past Productions`
};

@Component({
  selector: 'ush-app-productions',
  templateUrl: './productions.component.html',
  styleUrls: ['./productions.component.scss'],
  standalone: false
})
export class ProductionsComponent {
  movies!: Movie[];

  private readonly CAST_ROLE = 'Actor';
  moviesCast!: string[];

  _title: string;
  get title(): string {
    return this._title;
  }
  set title(tag: string) {
    this._title = productionsTranslations[tag] || tag;
  }

  get channelSettings() {
    return this.channelService.channel.settings;
  }

  constructor(
    private channelService: ChannelService,
    private readonly movieService: MovieService,
    private readonly route: ActivatedRoute
  ) {
    this.listenRouteData();
  }

  listenRouteData() {
    this.route.data.subscribe(data => {
      const { tag } = data;
      this.title = tag;
      this.loadMoviesTag(tag);
    });
  }

  loadMoviesTag(tag: string) {
    this.movieService
      .getMovies('all', {
        tags: [tag]
      })
      .subscribe({
        next: movies => {
          this.movies = movies;
          this.setMoviesCast();
        }
      });
  }

  setMoviesCast() {
    this.moviesCast = this.movies.map(movie => {
      const customMovieCrew = movie?.customMovieCrew ? JSON.parse(movie?.customMovieCrew) : null;
      if (customMovieCrew && customMovieCrew?.Cast) {
        return customMovieCrew.Cast;
      } else {
        const actors = movie?.movieCrew?.filter(member => member.crewRole.name === this.CAST_ROLE) || [];
        return actors.map(actor => actor.star.name).join(', ');
      }
    });
  }

  /**
   * Sets {@link movieTagClass}.
   */
  isNoMovieTagPresent(movie): boolean {
    return !!movie?.tags?.find(tag => tag.friendlyUrl == 'no-movie-detail');
  }
}
